import * as React from 'react'
import Menu from 'shared/components/Menu'
import MenuItem from 'shared/components/MenuItem'
import Pages from 'components/AppRouter/Pages'
import { Nav, Navbar as Bnavbar} from "react-bootstrap"
import MenuItemLogout from 'shared/components/MenuItemLogout'
import hasAnyRole from 'shared/utils/hasAnyRole'

interface NavbarProps {
    title: string
    menuBottomInsert?: React.FunctionComponent | React.ReactElement | string | false
}

const Navbar: React.FunctionComponent<NavbarProps> = (props) => {

    return (
        <Bnavbar expand="disable" className="d-lg-none d-xl-none" variant='dark'>
            <Bnavbar.Brand href="#home">
                <h3>{props.title}</h3>
            </Bnavbar.Brand>
            <Bnavbar.Toggle aria-controls="basic-navbar-nav" />
            <Bnavbar.Collapse id="basic-navbar-nav">
                <Menu position="left" showLogOut={true} bottomInsert={props.menuBottomInsert} menuId={2} />
            </Bnavbar.Collapse>
        </Bnavbar>
    );
}

export default Navbar